<template>
    <div>

        <v-layout row wrap>
            <v-flex md4 offset-md4 class="add-new-card-container">
                
                <v-layout row wrap>
                    <v-flex md12 class="add-new-card-header">

                        <h4>Card Details:</h4>
                        <div class="add-new-card-buton"
                        @click="addCard">
                            Add new card<IconBase><IconAddCard /></IconBase>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex md12>
                        <div v-if="!isLoading">
                            <v-layout>
                                <v-flex md8 offset-md2>
                                    <OnlineRenewalCreateCustomer ref="createCustomerRef"/>
                                </v-flex>
                            </v-layout>

                            <br/>

                            <v-layout row wrap v-if="cards.length">
                                <v-flex md8 offset-md2 v-for="card in cards" :key="card.id">
                                    <ins-credit-card
                                        v-bind:active="card.id == selectedCard.id"
                                        v-bind:expired="checkExpiration(card.properties.exp_month, card.properties.exp_year)"
                                        v-bind:brand="card.properties.brand"
                                        v-bind:last-four="card.properties.last4"
                                        v-bind:expiry-month="card.properties.exp_month"
                                        v-bind:expiry-year="card.properties.exp_year"
                                        v-bind:full-year="true"
                                        v-bind:value="card.id"
                                        v-on:insCreditCardClicked="select(card)"
                                        v-on:insCreditCardClosed="confirmDelete"
                                        class="credit-card-item"
                                        >
                                    </ins-credit-card>
                                </v-flex>
                            </v-layout>
                            
                        </div>
                        <div v-else>
                            <div class="text-center">
                                <v-progress-circular
                                indeterminate
                                color="blue"
                                ></v-progress-circular>
                                <!-- <a-spin tip="Loading...">
                                    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                                </a-spin> -->
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
                <br/>
            </v-flex>
        </v-layout>

        <br />

        <v-layout v-if="selectedCard !== undefined">
            <v-flex md4 offset-md4>
                <button class="green-button"
                    @click="proceedWithPayment()">
                    PAY ${{totalPayable}}
                </button>
            </v-flex>
        </v-layout>
        
    </div>
</template>

<style scoped>
.add-new-card-container {
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}
.add-new-card-header {
    display: flex;
    align-items: center;
    justify-content: center;
}
.add-new-card-buton {
    color: #0072BC;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    font-weight: bold;
    text-transform: uppercase;
}
.add-new-card-buton svg {
    margin-left: 10px;
    height: 30px;
    width: 30px;
}
</style>

<script>
import OnlineRenewalCreateCustomer from '@/components/OnlineRenewalCreateCustomer.vue'

export default {
    components: {
        OnlineRenewalCreateCustomer
    },
    props: {
        totalPayable: String,
        idempotencyKey: String,
    },
    data() {
        return {
            cards: [],
            selectedCard: undefined,
            addDialogState: false,
            isMounted: false,
            isLoading: true
        }
    },
    methods: {
        async proceedWithPayment() {
            let customerDetails = this.getCustomer();

            if(customerDetails.state) {
                let request = {
                    currency: "AUD",
                    amount: Math.trunc(this.totalPayable * 100),
                    description: "FDCA Policy Payment - 1 pcs",
                    statement_description: "",
                    customer: customerDetails.result.properties.gateway_customer_id,
                    idempotency_key: this.idempotencyKey,
                    metadata: {
                        base_url: this.baseURL,
                        // description: this.idempotencyKey,
                        description: `${this.$store.state.sessionDetails.id}-${this.$store.state.quoteDetails.id}`,
                        token: document.getElementsByName('cmb-api-token')[0].content,
                        token_name: "cmb-auth",
                        transactions_api_token: this.transactionsAPIToken,
                        type: 'quick_quote',
                        env: this.environment,
                        
                        user_id: this.$store.state.sessionDetails.user_id,
                        user_type: this.$store.state.sessionDetails.properties.user_type,
                        business_name: this.$store.state.sessionDetails.properties.business_name,
                        add_ons_cover: this.$store.state.sessionDetails.properties.additional_cover_code,
                        package_code: this.$store.state.sessionDetails.properties.package_code,
                        start_date: this.$store.state.sessionDetails.properties.policy_start,
                        end_date: this.$store.state.sessionDetails.properties.policy_expiry,
                        service_information: "",
                        post_all_documents: this.$store.state.sessionDetails.properties.post_all_documents,
                        registered_for_gst: this.$store.state.sessionDetails.properties.registered_for_gst,
                        abn: this.$store.state.sessionDetails.properties.abn,
                        registered_service: "",
                        policy_type: this.$store.state.sessionDetails.properties.policy_type,
                        membership_output_membership_base: "",
                        membership_output_membership_base_gst: "",
                        membership_tl_addon_base: "",
                        membership_tl_addon_base_gst: "",
                        membership_dr_addon_base: "",
                        membership_dr_addon_base_gst: "",
                        membership_addons_base: "",
                        membership_addons_base_gst: "",
                        membership_addons_total: "",
                        transaction_type: this.$store.state.sessionDetails.properties.transaction_type
                    }
                }

                let payload = {
                    method: 'post',
                    url: `${this.baseURL}/api/fdca/quote/payment/create-payment.json`,
                    data: request
                },
                response = await this.$store.dispatch('fetchData', payload);
                if(response.data.api_call_send.errors.length === 0) {
                    
                    let card_errors = response.data.api_call_send.response.body.includes("error") ? 1 : 0;
                    if (card_errors === 0) {
                        let updateSessionStatusPayload = {
                            method: 'put',
                            url: `${this.baseURL}/api/cfa/update_session_status.json`,
                            data: {
                                id: this.$store.state.sessionDetails.id,
                                session_status: 'closed'
                            }
                        },
                        updateSessionStatusResponse = await this.$store.dispatch('fetchData', updateSessionStatusPayload);

                        this.$store.commit('mutate', {
                            property: 'onlineRenewalPaymentSuccess',
                            value: true
                        })
                        this.$store.commit('mutate', {
                            property: 'onlineRenewalStep',
                            value: this.$store.state.onlineRenewalStep + 1
                        })

                    } else {
                        //errors.forEach(error => this.filterError(error.message))
                        let message = JSON.parse(response.data.api_call_send.response.body);
                        this.validating = false;
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: message.error.message,
                            allowOutsideClick: false
                        });
                        this.errorStripe = 1;
                    }
                    
                } else {

                }
                
            }
        },
        /**
         * Loads the gateway credentials (settings)
         */
        init: async function () {
            if (!InsitesGatewaySettings.get().hasLoaded) {
                var state = await InsitesGatewaySettings.load()
                if (state) {
                    this.settings = InsitesGatewaySettings.get()
                    this.isMounted = true;
                }
            } else {
                this.settings = InsitesGatewaySettings.get()
                this.isMounted = true;
            }
        },
        
        /**
         * Gets the cards of the user
         */
        getCards: async function () {
            this.isLoading = true;
            let payload = {
                method: 'get',
                url: `${this.baseURL}/main/get_credit_cards_by_user_id.json`,
                params: {
                    id: this.$store.state.sessionDetails.user_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            },
            response = await this.$store.dispatch('fetchData', payload);
            this.cards = response.data.results;
            if (this.cards.length) {
                this.selectedCard = this.cards[0]
            } else {
                this.selectedCard = undefined;
            }
            setTimeout(() => {
                this.$refs.createCustomerRef.$refs.cardDetailsRef.onMount();
            }, 200)

            this.isLoading = false;
        },

        /**
         * Handles the selected card value
         * @param {Object} card the card to be selected (active)
         */
        select: function (card) {
            this.selectedCard = card
        },

        /**
         * Creates confirmation dialog for deleting card
         * @param {Event} event Card component event
         */
        confirmDelete: function (event) {
            var vm = this;
            Swal.fire({
                title: 'Are you sure? ',
                text: "Deleting this card will remove it from your account.",
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#1E86E3',
                cancelButtonColor: '#F27474',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                   vm.deleteCard(event.detail.value)
                }
            });
        },

        /**
         * Sends request to delete card
         * @param {String} id `credit_card` Model ID
         */
        deleteCard: async function ($id) {
            let payload = {
                method: 'delete',
                url: `${this.baseURL}/main/delete_stripe_card.json?id=${$id}`
            };
                
            this.$store.dispatch('fetchData', payload)
            .then(response => {
                response.data.properties.request_errors && response.data.properties.request_errors.length
                ? this.filterError(response.data.properties.request_errors)
                : (
                    this.getCards(),
                    // this.notify("success", "Success", "Card has been deleted")
                    parent.toastr.success("Card has been deleted")
                )
            })
            .catch(error => {
                // this.notify("error", "An Error has occured", "Failed to delete card")
                parent.toastr.error("Failed to delete card")
            })
        },

        filterError: function(err){
            let message = err;
            if (err.includes("Invalid API Key")){
                message = "Invalid API Key.";
            } else if (err.includes("No such customer")){
                message = "Your account was not found on the Gateway.";
            } else if (err.includes("No such source") || err.includes("No such token")){
                message = "Your card was not found on the Gateway.";
            }
            message += " Please contact the website administrator.";
            // this.notify("error", "Error", message)
            parent.toastr.error(message)
        },
        /**
         * Creates a Notication message
         * @param {String} type         the type of the notification message (determines the color and icon of the notification)
         * @param {String} title        the title of the notication
         * @param {String} content      notication details
         */
        notify: function (type, title, content) {
            this.$notification[type]({ message: title, description: content });
        },

        /**
         * Validates if there is a selected card and returns its value
         * @description function for the parent component (create_charge)
         */
        getCustomer: function () {
            return this.selectedCard
                ? { state: true, result: this.selectedCard }
                : { state: false, result: this.selectedCard }
        },

        /**
         * Triggers the submit function of create-customer component
         */
        addCard: async function () {
            var response = await this.$refs.createCustomerRef.submitForm()
            if (response.state) {
                this.addDialogState = false;
                await this.getCards();
            }
            if (this.cards.length) this.selectedCard = this.cards[0]
        },

        /**
         * Handles the Ant Design Modal component for adding card
         */
        showDialog: function () {
            this.addDialogState = true;
            if (this.cards.length) {
                setTimeout(() => {
                    this.$refs.createCustomerRef.$refs.cardDetailsRef.onMount();
                }, 200)
                // this.$refs.createCustomerRef.$refs.cardDetailsRef.onMount();
            }
        },

        /**
         * Checks whether the given month and year is expired (past)
         * @param {String} month Month number (begins from 1)
         * @param {String} year  Full Year (4 digits)
         * @returns {Boolean} result if month and year is expired
         */
        checkExpiration: function (month, year) {
            var currentDate = new Date(),
                currentMonth = currentDate.getUTCMonth(),
                currentYear = currentDate.getUTCFullYear()
            return ((parseInt(currentMonth) + 1) > month) && (parseInt(currentYear) >= year)
        }
    },
    mounted() {
        this.isMounted = true;
        this.getCards();
    }
}
</script>